import {
  TreeView,
  processTreeViewItems,
  handleTreeViewCheckChange,
  TreeViewExpandChangeEvent,
  TreeViewCheckDescriptor,
  ItemRenderProps,
} from '@progress/kendo-react-treeview'
import {
  SurveyEngine_Models_RecruitResponse,
  SurveyEngine_Models_SESurveyConfirmOperation,
  SurveyEngine_Models_Session,
  SurveyEngine_Models_SessionCollection,
  SurveyEngine_Models_SessionType,
} from '../../../api'
import { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCalendarCircle,
  faSquareInfo,
  faCalendarLines,
  faClock,
  faCheckCircle,
  faCircleExclamation,
  faDiagramNested,
} from '@fortawesome/pro-regular-svg-icons'
import { format } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { Error, Hint } from '@progress/kendo-react-labels'
import { useGlobalCtx } from '../../../Context/GlobalContext'
import { Button } from '@progress/kendo-react-buttons'
import {
  useRecruitCtx,
  useRecruitDispatchCtx,
} from '../../../Context/RecruitContext'
import { ScheduleState, SelectedSession } from '../../../Common'
import { useSurveyCtx } from '../../../Context/SurveyContext'
import parse from 'html-react-parser'

interface ClusterSessionProps {
  id: number
  message: string
  studyName: string
  sessions: SurveyEngine_Models_SessionCollection
  selectedSession: Array<SelectedSession>
  panelistTimeZone: string
  postSurvey: boolean
  getSubmitPendingConfirmation?: (
    surveySID: string,
    payLoad: SurveyEngine_Models_RecruitResponse,
    operation: SurveyEngine_Models_SESurveyConfirmOperation
  ) => void
}
export enum TreeViewDataItem_StatusType {
  NONE = 'None',
  ERROR = 'Error',
  SUCCESS = 'Success',
}
interface TreeViewDataItem {
  id?: number
  name?: string
  min?: number
  max?: number
  sessionType?: SurveyEngine_Models_SessionType
  startTime?: string
  endTime?: string
  room?: string
  isOverFlow?: boolean
  defaultSelected?: boolean
  items: TreeViewDataItem[]
  expanded?: boolean
  checked?: boolean
  selected?: boolean
  disabled?: boolean
  hasChildern?: boolean
  panelistTimeZone: string
  status: TreeViewDataItem_StatusType
  treeIndex: string
}
interface sessionSelectionStatus {
  status: boolean
  selectionCount: number
}
const MyItem2 = (itemProps: ItemRenderProps) => {
  const globalCtx = useGlobalCtx()
  return (
    <>
      {itemProps.item.items && itemProps.item.items.length > 0 ? (
        <div className="theme-session-cluster-name w-full">
          <div className="block w-full">
            <div className="text-xl font-semibold">
              {/* <FontAwesomeIcon icon={itemProps.item.sessionType === SurveyEngine_Models_SessionType.SESSION ? faCalendarCircle : faCalendarPlus} /> {`${itemProps.item.name}`} */}
              {`${itemProps.item.name}`}
            </div>

            {itemProps.item.sessionType ===
              SurveyEngine_Models_SessionType.SESSION &&
              itemProps.item.startTime &&
              itemProps.item.endTime && (
                <div className="xl:flex xl:flex-row xl:justify-between w-full my-2">
                  <div className="xl:text-base md:text-sm text-xs basis-1/2 font-bold">
                    <FontAwesomeIcon
                      className="theme-icon-spacer"
                      icon={faCalendarCircle}
                    />
                    {format(
                      new Date(itemProps.item.startTime!),
                      'EEEE, MMMM dd, yyyy'
                    )}
                  </div>
                  <div className="xl:text-base md:text-sm text-xs basis-1/2 font-medium xl:text-right">
                    <FontAwesomeIcon
                      className="theme-icon-spacer"
                      icon={faClock}
                    />
                    {`${String(
                      formatInTimeZone(
                        new Date(itemProps.item?.startTime!),
                        itemProps.item.panelistTimeZone,
                        'h:mm aaa'
                      )
                    ).toUpperCase()} 
                                     to ${String(
                                       formatInTimeZone(
                                         new Date(itemProps.item?.endTime!),
                                         itemProps.item.panelistTimeZone,
                                         'h:mm aaa'
                                       )
                                     ).toUpperCase()}`}
                  </div>
                </div>
              )}
          </div>
          {itemProps.item.status === TreeViewDataItem_StatusType.ERROR && (
            <Hint
              className="theme-validator-error-text text-wrap font-semibold mt-2"
              direction="start"
            >
              <FontAwesomeIcon
                className="theme-icon-spacer pt-0.5"
                icon={faCircleExclamation}
              />
              <div className={'pt-[3px]'}>
                {globalCtx.LangResources.recruitMsg.clusterMessage
                  .replace('{min}', itemProps.item.min)
                  .replace('{max}', itemProps.item.max)}
              </div>
            </Hint>
          )}
          {itemProps.item.status === TreeViewDataItem_StatusType.NONE && (
            <Hint
              className="theme-validator-hint-text text-wrap font-semibold mt-2"
              direction="start"
            >
              <FontAwesomeIcon
                className="theme-session-cluster-hint-icon theme-icon-spacer"
                icon={faDiagramNested}
              />
              <div className={'theme-session-cluster-hint pt-[3px]'}>
                {globalCtx.LangResources.recruitMsg.clusterMessage
                  .replace('{min}', itemProps.item.min)
                  .replace('{max}', itemProps.item.max)}
              </div>
            </Hint>
          )}
          {itemProps.item.status === TreeViewDataItem_StatusType.SUCCESS && (
            <Hint
              className="theme-validator-success-text text-wrap font-semibold mt-2"
              direction="start"
            >
              <FontAwesomeIcon
                className="theme-icon-spacer pt-0.5"
                icon={faCheckCircle}
              />
              <div className={'pt-[3px]'}>
                {globalCtx.LangResources.recruitMsg.clusterMessage
                  .replace('{min}', itemProps.item.min)
                  .replace('{max}', itemProps.item.max)}
              </div>
            </Hint>
          )}
        </div>
      ) : (
        <div className="theme-session-cluster-date-time w-full">
          <div className="xl:flex xl:flex-row xl:justify-between">
            <div className="xl:text-base md:text-sm text-xs basis-1/2 font-bold">
              <FontAwesomeIcon
                className="theme-icon-spacer"
                icon={faCalendarCircle}
              />
              <span className="text-wrap">
                {format(
                  new Date(itemProps.item.startTime!),
                  'EEEE, MMMM dd, yyyy'
                )}
              </span>
            </div>
            <div className="xl:text-base md:text-sm text-xs basis-1/2 font-medium xl:text-right text-wrap">
              <FontAwesomeIcon className="theme-icon-spacer" icon={faClock} />
              {`${String(
                formatInTimeZone(
                  new Date(itemProps.item.startTime!),
                  itemProps.item.panelistTimeZone,
                  'h:mm aaa'
                )
              ).toUpperCase()} 
                            to ${String(
                              formatInTimeZone(
                                new Date(itemProps.item.endTime!),
                                itemProps.item.panelistTimeZone,
                                'h:mm aaa'
                              )
                            ).toUpperCase()}`}
            </div>
          </div>
          <div className="xl:text-base md:text-sm text-xs font-medium xl:ml-1.5 md:ml-1 ml-px sm:pl-4 pl-0">{`${itemProps.item.name}`}</div>
        </div>
      )}
    </>
  )
}

export const Cluster = (props: ClusterSessionProps) => {
  const [check, setCheck] = useState<
    | any[]
    | (TreeViewCheckDescriptor & {
        ids: any[]
      })
  >({
    ids: [],
    applyCheckIndeterminate: true,
  })
  const [expanded, setExpanded] = useState<{ ids: Array<string> }>({ ids: [] })
  const [sessions, setSessions] = useState<Array<TreeViewDataItem>>([])
  let selectedSessions = useRef<Array<SelectedSession>>([])

  let treeViewRef = useRef<any>()
  let errorRef = useRef<any>()
  const recruitCtxDispatch = useRecruitDispatchCtx()

  const [isSelectionValid, setIsSelectionValid] = useState(false)
  const [isTouched, setIsTouched] = useState(false)
  const globalCtx = useGlobalCtx()
  const recruitCtx = useRecruitCtx()
  const surveyCtx = useSurveyCtx()
  // const {isMobile} = useCheckMobileScreen()

  function checkSelection(
    treeSessions: Array<TreeViewDataItem>,
    invalidClusters: Set<number>,
    addParentSessionCluster: boolean,
    min: number,
    max: number
  ): boolean {
    if (treeSessions) {
      let validCount = 0
      let selectionCount = 0
      for (let s = 0; s < treeSessions.length; s++) {
        let status = checkNodeSelection(
          treeSessions[s],
          invalidClusters,
          addParentSessionCluster
        )
        if (status.status) {
          validCount++
        }
        if (status.selectionCount > 0) {
          selectionCount++
        }
      }
      if (
        validCount >= min &&
        validCount <= max &&
        validCount === selectionCount
      ) {
        return true
      }
    }
    return false
  }

  function checkNodeSelection(
    treeSession: TreeViewDataItem,
    invalidClusters: Set<number>,
    addParentSessionCluster: boolean
  ): sessionSelectionStatus {
    if (treeSession.items?.length > 0) {
      let selectionCount = 0
      let validCount = 0
      for (let s = 0; s < treeSession.items?.length; s++) {
        let status = checkNodeSelection(
          treeSession.items[s],
          invalidClusters,
          addParentSessionCluster
        )
        if (status.status) {
          validCount++
        }
        if (status.selectionCount > 0) {
          selectionCount++
        }
      }

      if (
        validCount >= treeSession.min! &&
        validCount <= treeSession.max! &&
        validCount === selectionCount
      ) {
        invalidClusters.delete(treeSession.id!)
        if (treeSession.min === 0 && selectionCount === 0) {
          treeSession.status = TreeViewDataItem_StatusType.NONE
        } else {
          treeSession.status = TreeViewDataItem_StatusType.SUCCESS
          // addParentSessionCluster flag decides if we need to add the parnet session which is laos a cluster as there is a child under that is selected.
          // this flag will be set to true only during the on scheudle
          if (
            treeSession.sessionType ===
              SurveyEngine_Models_SessionType.SESSION &&
            addParentSessionCluster
          ) {
            if (
              selectedSessions.current.findIndex(
                (s) => s.sessionId === treeSession.id
              ) === -1
            ) {
              selectedSessions.current.push({
                sessionId: treeSession.id!,
                sessionDay: format(
                  new Date(treeSession.startTime!),
                  'EEEE, MMMM dd, yyyy'
                ),
                sessionName: treeSession.name!,
                sessionStartTime: String(
                  formatInTimeZone(
                    new Date(treeSession.startTime!),
                    props.panelistTimeZone,
                    'h:mm aaa'
                  )
                ).toUpperCase(),
                sessionEndTime: String(
                  formatInTimeZone(
                    new Date(treeSession.endTime!),
                    props.panelistTimeZone,
                    'h:mm aaa'
                  )
                ).toUpperCase(),
                isOverFlow: false,
                subSession: [],
              })
            }
          }
        }

        return {
          status: treeSession.min === 0 && selectionCount === 0 ? false : true,
          selectionCount: selectionCount,
        }
      } else {
        if (
          selectionCount > 0 ||
          (selectionCount === 0 &&
            treeSession.sessionType ===
              SurveyEngine_Models_SessionType.SESSION &&
            selectedSessions.current.findIndex(
              (s) => s.sessionId === treeSession.id!
            ) !== -1)
        ) {
          treeSession.status = TreeViewDataItem_StatusType.ERROR
        } else {
          treeSession.status = TreeViewDataItem_StatusType.NONE
        }
        invalidClusters.add(treeSession.id!)
        return {
          status: false,
          selectionCount: selectionCount,
        }
      }
    } else {
      let index = selectedSessions.current.findIndex(
        (s) => s.sessionId === treeSession.id!
      )

      if (index === -1) {
        return {
          status: false,
          selectionCount: 0,
        }
      } else {
        return {
          status: true,
          selectionCount: 1,
        }
      }
    }
  }

  const clearError = (treeSessions: Array<TreeViewDataItem>) => {
    if (treeSessions) {
      for (let n = 0; n < treeSessions.length; n++) {
        clearNodeError(treeSessions[n])
      }
      window.scrollTo(0, 0)
      return true
    }
    return false
  }

  const clearNodeError = (treeSession: TreeViewDataItem) => {
    if (treeSession.items?.length > 0) {
      for (let s = 0; s < treeSession.items?.length; s++) {
        clearNodeError(treeSession.items[s])
      }
    }
    if (treeSession.status === TreeViewDataItem_StatusType.ERROR) {
      treeSession.status = TreeViewDataItem_StatusType.NONE
    }
    return true
  }

  const transformNodes = (
    cluster: Array<SurveyEngine_Models_Session>,
    treeSessions: TreeViewDataItem,
    mappedList: Set<{ sessionId: number; treeIndex: string }>,
    index: string
  ) => {
    let sessionSubIndex = 0
    for (let s = 0; s < cluster.length; s++) {
      if (cluster[s].sessions && cluster[s].sessions!.length > 0) {
        //cluster
        let node: TreeViewDataItem = {
          name: cluster[s].name!,
          min: cluster[s].min!,
          max: cluster[s].max!,
          sessionType: cluster[s].sessionType,
          id: cluster[s].id ?? -1,
          startTime: cluster[s].startTime!,
          endTime: cluster[s].endTime!,
          defaultSelected: cluster[s].selected!,
          room: cluster[s].room!,
          isOverFlow: cluster[s].isOverFlow!,
          disabled: false,
          items: [],
          panelistTimeZone: props.panelistTimeZone,
          status: TreeViewDataItem_StatusType.NONE,
          treeIndex: `${index}${sessionSubIndex}`,
        }
        mappedList.add({
          sessionId: cluster[s].id ?? -1,
          treeIndex: `${index}${sessionSubIndex}`,
        })
        transformNodes(
          cluster[s].sessions!,
          node,
          mappedList,
          `${index}${sessionSubIndex}_`
        )
        treeSessions.items?.push(node)
        sessionSubIndex++
      } else {
        if (
          cluster[s].sessionType === SurveyEngine_Models_SessionType.SESSION
        ) {
          let session: SurveyEngine_Models_Session = cluster[
            s
          ] as SurveyEngine_Models_Session

          let clusterSession: TreeViewDataItem = {
            name: session.name!,
            min: session.min!,
            max: session.max!,
            sessionType: session.sessionType,
            items: [],
            id: session.id!,
            startTime: session.startTime!,
            endTime: session.endTime!,
            defaultSelected: session.selected!,
            room: session.room!,
            isOverFlow: session.isOverFlow!,
            disabled: false,
            panelistTimeZone: props.panelistTimeZone,
            status: TreeViewDataItem_StatusType.NONE,
            treeIndex: `${index}${sessionSubIndex}`,
          }
          mappedList.add({
            sessionId: cluster[s].id!,
            treeIndex: `${index}${sessionSubIndex}`,
          })
          treeSessions.items?.push(clusterSession)
          sessionSubIndex++
        }
      }
    }
  }
  const transformSessions = (
    cluster: Array<SurveyEngine_Models_Session>,
    treeSessions: Array<TreeViewDataItem>,
    mappedList: Set<{ sessionId: number; treeIndex: string }>
  ) => {
    if (cluster) {
      let indexCounter = 0
      for (let n = 0; n < cluster?.length; n++) {
        let level1Node: TreeViewDataItem = {
          name: cluster[n].name!,
          min: cluster[n].min!,
          max: cluster[n].max!,
          sessionType: cluster[n].sessionType,
          id: cluster[n].id ?? -1,
          startTime: cluster[n].startTime!,
          endTime: cluster[n].endTime!,
          defaultSelected: cluster[n].selected!,
          room: cluster[n].room!,
          isOverFlow: cluster[n].isOverFlow!,
          disabled: false,
          items: [],
          panelistTimeZone: props.panelistTimeZone,
          status: TreeViewDataItem_StatusType.NONE,
          treeIndex: `${indexCounter}`,
        }

        if (cluster[n].sessions && cluster[n].sessions!.length > 0) {
          transformNodes(
            cluster[n].sessions!,
            level1Node,
            mappedList,
            `${indexCounter}_`
          )
        }
        if (
          !(
            level1Node.sessionType ===
              SurveyEngine_Models_SessionType.SESSION_COLLECTION &&
            level1Node.items &&
            level1Node.items.length === 0
          )
        ) {
          treeSessions.push(level1Node)
          mappedList.add({
            sessionId: cluster[n].id ?? -1,
            treeIndex: `${indexCounter}`,
          })
          indexCounter++
        }
      }
    }
  }
  useEffect(() => {
    let treeSessions: Array<TreeViewDataItem> = []
    let mappedList: Set<{ sessionId: number; treeIndex: string }> = new Set()

    transformSessions(props.sessions.sessions!, treeSessions, mappedList)

    if (props.selectedSession?.length > 0) {
      let selectedTreeIndex = Array.from(mappedList)
        .filter(
          (e) =>
            props.selectedSession.findIndex(
              (s) =>
                s.sessionId === e.sessionId && s.isSessionAndCluster === false
            ) !== -1
        )
        .map((o) => o.treeIndex)

      selectedSessions.current = props.selectedSession.filter(
        (s) => s.isSessionAndCluster === false
      )

      let failedClusters: Set<number> = new Set()
      let validation = checkSelection(
        treeSessions,
        failedClusters,
        false,
        props.sessions.min!,
        props.sessions.max!
      )
      setIsSelectionValid(validation)
      if (validation) {
        clearError(treeSessions)
      }
      setCheck({ ids: selectedTreeIndex, applyCheckIndeterminate: true })
      setIsTouched(true)
    }

    setSessions([...treeSessions])
    setExpanded({ ids: Array.from(mappedList).map((e) => e.treeIndex) })
    treeViewRef.current?._element?.focus()
  }, [props])

  const updateSelectedSessions = (
    item: TreeViewDataItem,
    removeItems: boolean
  ) => {
    if (item.items && item.items.length > 0) {
      if (item.sessionType === SurveyEngine_Models_SessionType.SESSION) {
        if (removeItems) {
          let index = selectedSessions.current.findIndex(
            (s) => s.sessionId === item.id!
          )
          if (index !== -1) {
            selectedSessions.current.splice(index, 1)
          }
        } else {
          let index = selectedSessions.current.findIndex(
            (s) => s.sessionId === item.id!
          )
          if (index === -1) {
            selectedSessions.current.push({
              sessionId: item.id!,
              sessionDay: format(
                new Date(item.startTime!),
                'EEEE, MMMM dd, yyyy'
              ),
              sessionName: item.name!,
              sessionStartTime: String(
                formatInTimeZone(
                  new Date(item.startTime!),
                  props.panelistTimeZone,
                  'h:mm aaa'
                )
              ).toUpperCase(),
              sessionEndTime: String(
                formatInTimeZone(
                  new Date(item.endTime!),
                  props.panelistTimeZone,
                  'h:mm aaa'
                )
              ).toUpperCase(),
              isOverFlow: false,
              isSessionAndCluster: true,
            })
          }
        }
      }
      for (let i = 0; i < item.items.length; i++) {
        updateSelectedSessions(item.items[i], removeItems)
      }
    } else {
      if (removeItems) {
        let index = selectedSessions.current.findIndex(
          (s) => s.sessionId === item.id!
        )
        if (index !== -1) {
          selectedSessions.current.splice(index, 1)
        }
      } else {
        let index = selectedSessions.current.findIndex(
          (s) => s.sessionId === item.id!
        )
        if (index === -1) {
          selectedSessions.current.push({
            sessionId: item.id!,
            sessionDay: format(
              new Date(item.startTime!),
              'EEEE, MMMM dd, yyyy'
            ),
            sessionName: item.name!,
            sessionStartTime: String(
              formatInTimeZone(
                new Date(item.startTime!),
                props.panelistTimeZone,
                'h:mm aaa'
              )
            ).toUpperCase(),
            sessionEndTime: String(
              formatInTimeZone(
                new Date(item.endTime!),
                props.panelistTimeZone,
                'h:mm aaa'
              )
            ).toUpperCase(),
            isOverFlow: false,
            isSessionAndCluster: false,
          })
        }
      }
    }
  }

  const onCheckChange = (event: TreeViewExpandChangeEvent) => {
    if (event.item.checked && event.item.checked === true) {
      //checked will be true only when it is alreacy checked.
      updateSelectedSessions(event.item, true)
    } else {
      updateSelectedSessions(event.item, false)
    }

    const settings = {
      singleMode: false,
      checkChildren: true,
      checkParents: true,
    }
    const res = handleTreeViewCheckChange(event, check, sessions, settings)
    setCheck(res)

    let copyofTreeData: Array<TreeViewDataItem> = sessions.slice()
    let failedClusters: Set<number> = new Set()
    let validation = checkSelection(
      copyofTreeData,
      failedClusters,
      false,
      props.sessions.min!,
      props.sessions.max!
    )
    setIsSelectionValid(validation)
    if (validation) {
      clearError(copyofTreeData)
    } else {
      for (const node of copyofTreeData) {
        if (node.status === TreeViewDataItem_StatusType.ERROR) {
          //set focus for screen reader to read the error message of min and max sessions
          const parentNodeIndex = event.itemHierarchicalIndex.substring(0, 1)
          treeViewRef.current.element.focus()
          treeViewRef.current.element.childNodes[0].childNodes[
            parentNodeIndex
          ].focus()
        }
      }
    }
    setSessions([...copyofTreeData])
    setIsTouched(true)
    console.log(
      `Selected Session ID : ${selectedSessions.current.map(
        (selected: SelectedSession) => {
          return selected.sessionId
        }
      )}`
    )
  }
  const onExpandChange = (event: TreeViewExpandChangeEvent) => {
    let expand = expanded.ids.slice()
    const index = expand.indexOf(event.itemHierarchicalIndex)
    index === -1
      ? expand.push(event.itemHierarchicalIndex)
      : expand.splice(index, 1)
    setExpanded({ ids: expand })
  }
  const onDecline = () => {
    //we need to run this as we need to get the updated selection list to add any session cluster that needs to be included.
    // This is mainly done to remember all the session correctly when we
    let copyofTreeData: Array<TreeViewDataItem> = sessions.slice()
    let failedClusters: Set<number> = new Set()
    checkSelection(
      copyofTreeData,
      failedClusters,
      true,
      props.sessions.min!,
      props.sessions.max!
    )

    recruitCtxDispatch({
      type: 'ClusterSessionSelection',
      value: selectedSessions.current,
    })
    recruitCtxDispatch({ type: 'ScheduleState', value: ScheduleState.DECLINE })
  }
  const onSchedule = () => {
    let copyofTreeData: Array<TreeViewDataItem> = sessions.slice()
    let failedClusters: Set<number> = new Set()
    // addParentSessionCluster flag decides if we need to add the parent session which is a cluster as there is a child under that is selected.
    // this flag will be set to true only during the on schedule
    let validation = checkSelection(
      copyofTreeData,
      failedClusters,
      true,
      props.sessions.min!,
      props.sessions.max!
    )
    console.log(
      `Selected Session ID : ${selectedSessions.current.map(
        (selected: SelectedSession) => {
          return selected.sessionId
        }
      )}`
    )
    setIsSelectionValid(validation)
    if (validation === false) {
      treeViewRef.current.element.focus()

      //set focus to first invalid node if any nodes are touched for accessibility
      var unTouchedNodes = copyofTreeData.filter(
        (el) => el.status === TreeViewDataItem_StatusType.NONE
      )
      if (unTouchedNodes?.length !== copyofTreeData.length) {
        for (const node of copyofTreeData) {
          if (
            node.status === TreeViewDataItem_StatusType.NONE ||
            node.status === TreeViewDataItem_StatusType.ERROR
          ) {
            treeViewRef.current.element.childNodes[0].childNodes[
              node.treeIndex
            ].focus()
            break
          }
        }
      }
      setSessions([...copyofTreeData])
      setIsTouched(true)

      var errorElem = (errorRef.current as HTMLDivElement).querySelector(
        '.k-form-error'
      ) as HTMLDivElement
      if (errorElem !== null) {
        treeViewRef.current.element.setAttribute(
          'aria-describedby',
          `ClusterSessionSelectionerr_${props.id}`
        )
      }
      window.scrollTo(0, 0)
    } else {
      recruitCtxDispatch({
        type: 'ClusterSessionSelection',
        value: selectedSessions.current,
      })
      if (
        recruitCtx.currentState === ScheduleState.POST_SURVEY_RESCHEDULE ||
        recruitCtx.currentState ===
          ScheduleState.POST_SURVEY_COMPLETED_DIALOG ||
        recruitCtx.currentState === ScheduleState.POST_SURVEY_CANCELLED
      ) {
        recruitCtxDispatch({
          type: 'ScheduleState',
          value: ScheduleState.POST_SURVEY_RESCHEDULE_CONFIRM,
        })
      } else {
        var res: SurveyEngine_Models_RecruitResponse = {
          commandIndex: props.id,
          commandType: 'Recruit',
          declined: false,
          eventUrl: '',
          inviteeUrl: '',
          sessionIds: selectedSessions.current.map((item) => {
            return item.sessionId
          }),
        }
        if (props.getSubmitPendingConfirmation) {
          props.getSubmitPendingConfirmation(
            surveyCtx.StartSurvey.surveyInstanceId!,
            res,
            SurveyEngine_Models_SESurveyConfirmOperation.PENDING_CONFIRMATION
          )
          //({ type: "ScheduleState", value: ScheduleState.CONFIRM });
        } else {
          console.log('getSubmitPendingConfirmation is null')
        }
      }
    }
  }

  const onSkip = () => {
    // window.open(globalCtx.RedirectUrl, '_parent')
    window.location.href = globalCtx.RedirectUrl
  }

  return (
    <div className="theme-session mb-3 w-full block">
      <div className="flex flex-col mb-4">
        <div className="theme-session-header w-full block">
          <FontAwesomeIcon
            icon={faCalendarLines}
            className="theme-session-header-icon"
          />
          <span
            id={`ClusterSessionSelection_${props.id}`}
            className="theme-session-header-text ml-2 text-3xl font-regular"
          >
            {globalCtx.LangResources.recruitMsg.selection.heading}
          </span>
        </div>
      </div>

      <div className="flex flex-col mb-4">
        <div
          id={`studyName_${props.id}`}
          className="text-base font-semibold pb-2"
        >
          <FontAwesomeIcon
            icon={faCalendarLines}
            className="theme-icon-spacer"
          />
          {globalCtx.LangResources.recruitMsg.studyMsg.replace(
            '{StudyName}',
            props.studyName
          )}
        </div>
        <div
          id={`ClusterSessionSelectionmsg_${props.id}`}
          className="text-base font-normal pb-2"
        >
          <FontAwesomeIcon icon={faSquareInfo} className="theme-icon-spacer" />{' '}
          <span className="theme-session-message">
            {parse(props.message.replace(/""/g, '"'))}
          </span>
        </div>
      </div>

      <div className="flex flex-col mb-4" ref={errorRef}>
        {/* <div id={`studyName_${props.id}`} className="pb-2 lg:text-lg md:text-base text-xs font-semibold">{globalCtx.LangResources.recruitMsg.studyMsg.replace("{StudyName}", props.studyName)}</div> */}
        {/* <div className="pb-2" id={`ClusterSessionSelectionmsg_${props.id}`}>{props.message}</div> */}
        {isSelectionValid && isTouched && (
          <Hint
            id={`ClusterSessionSelectionerr_${props.id}`}
            className="theme-validator-success-text font-semibold"
            direction="start"
          >
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="theme-icon-spacer"
            />
            {globalCtx.LangResources.recruitMsg.clusterSuccessMsg}
          </Hint>
        )}
        {!isSelectionValid && isTouched && (
          <Error
            id={`ClusterSessionSelectionerr_${props.id}`}
            className="theme-validator-error-text font-semibold"
            direction="start"
          >
            <FontAwesomeIcon
              icon={faCircleExclamation}
              className="theme-icon-spacer"
            />
            {globalCtx.LangResources.recruitMsg.clusterMessage
              .replace('{min}', props.sessions.min)
              .replace('{max}', props.sessions.max)}
          </Error>
        )}
      </div>

      <TreeView
        className={'theme-session-cluster'}
        aria-labelledby={`ClusterSessionSelection_${props.id} studyName_${props.id} ClusterSessionSelectionmsg_${props.id}`}
        // size={`${isMobile ? "small" : "large"}`}
        data={processTreeViewItems(sessions, {
          check: check,
          expand: expanded,
        })}
        expandIcons={false}
        checkboxes={true}
        onCheckChange={onCheckChange}
        onExpandChange={onExpandChange}
        item={MyItem2}
        hasChildrenField=""
        tabIndex={0}
        ref={treeViewRef}
      />
      {!props.postSurvey && (
        <div
          className={
            'theme-btn-container min-h-[5vh] block md:flex flex-row-reverse justify-between content-center pt-8 pb-2 mt-8'
          }
        >
          <div className="md:flex-row ">
            <Button
              className="theme-btn-schedule w-full md:w-auto"
              data-testid="schedule-button"
              onClick={onSchedule}
            >
              {globalCtx.LangResources.recruitMsg.scheduleButton}
            </Button>
          </div>
          <div className="my-2 md:flex-row md:my-0">
            <Button
              className="theme-btn-decline w-full md:w-auto"
              data-testid="decline-btn"
              onClick={onDecline}
            >
              {globalCtx.LangResources.recruitMsg.declineButton}
            </Button>
          </div>
        </div>
      )}
      {props.postSurvey && (
        <div
          className={
            'theme-btn-container min-h-[5vh] md:flex flex-row-reverse justify-between pt-8 pb-2 mt-8'
          }
        >
          <div className="md:basis-1 lg:basis-1/3 lg:px-4">
            <div className="flex flex-col">
              <Button
                id="continueButton"
                className="theme-btn-schedule w-full"
                data-testid="continue-button"
                onClick={onSchedule}
                aria-labelledby="continueMsg continueButton"
              >
                {globalCtx.LangResources.recruitMsg.rescheduleContinueButton ??
                  'Continue'}
              </Button>
              <div id="continueMsg" className="text-center text-sm pt-2">
                {globalCtx.LangResources.recruitMsg.rescheduleContinueButtonMsg}
              </div>
            </div>
          </div>
          <div className="md:basis-1 lg:basis-1/3 lg:px-4">
            <div className="flex flex-col">
              <Button
                id="skipButton"
                className="theme-btn-skip w-full"
                data-testid="skip-button"
                onClick={onSkip}
                aria-labelledby="skipMsg skipButton"
              >
                {globalCtx.LangResources.recruitMsg.skipButton ?? 'Skip'}
              </Button>
              <div id="skipMsg" className="text-center text-sm pt-2">
                {globalCtx.LangResources.recruitMsg.skipButtonMsg}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
